import { EmptyValuePlaceholder } from "@/components/ui"
import { formatDate } from '@/utils/formatters'

export default ({item}) => {
 
  return (
    <tr>
      <td>{ item.prestataire?.nom_complet ? 
          item.prestataire?.nom_complet :
          <EmptyValuePlaceholder />
      }
      </td>
      <td>
        <EmptyValuePlaceholder value={formatDate(item.date_prestation)} />
      </td>
      <td>
        <EmptyValuePlaceholder value={item.entretien_type_description || item.entretien_type_nom} />
      </td>
    </tr>
  )
}